import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const VerticalAlignSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="Vertical Align"
      options={['', 'top','middle','bottom']}
      {...props}
    />
  )
}

VerticalAlignSelector.propTypes = {}
VerticalAlignSelector.defaultProps = {}

export default VerticalAlignSelector



// WEBPACK FOOTER //
// ./src/components/forms/VerticalAlignSelector.js